import { env } from '@campai/lib-web/env'
import { type OrganizationCountryCode } from '@campai/lib-common/entities'

// These are the countries that we allow new orgs to be created at
// Currently its only used here
// TODO: probably should be moved to a place where we have the product specifications
export const newOrganizationAvailableCountries: OrganizationCountryCode[] =
    env.VITE_PRODUCT_KEY === 'wunderpass' ? ['US'] : ['DE', 'LU', 'AT']
